import { useAccess } from 'components/hooks/access'
import { ViewContext } from 'components/lib'
import { ToolGeneratorLayoutPrimary } from 'ui'
import { useContext } from 'react'
import UpgradePlan from '../UpgradePlan'
import WriterHeader from '../WriterHeader'
import ModifyTextActions from './ModifyTextActions'
import ModifyTextOptions from './ModifyTextOptions'

const ModifyTextGenerator = ({
  visible,
  dispatch,
  actionTypes,
  setWordLength,
  setMyText,
  wordLength,
  setWriterLengthOption,
  writerLengthOption,
  setCreativity,
  creativity,
  optionsData,
  loading,
  handleSubmitWriterOptions,
  templateOptions,
  setTemplateId,
  setWhatToDo,
  setKeyWords,
  clearInputs,
  setModalIsVisible,
  templateId,
  handleDeleteTemplate,
  isShowAdvanced,
  setIsShowAdvanced,
  isOptimizedForSeoEnabled,
  setIsOptimizedForSeoEnabled,
  isGuruModeEnabled,
  setIsGuruModeEnabled,
  isHistoryVisible,
  setIsHistoryVisible,
  documentContext,
  model,
  setModel,
}) => {
  const context = useContext(ViewContext)
  const hasAccess = useAccess()
  const allowStandard = hasAccess('Standard')

  const showUpgradePlanModal = (availableFrom = 'Standard') => {
    context.modal.show({
      children: <UpgradePlan availableFrom={availableFrom} />,
      modalCardClassNames: '!bg-transparent !px-[0px] !py-[0px]',
    })
  }

  const showSaveModal = (availableFrom) => {
    if (allowStandard) {
      setModalIsVisible({ content: 'SAVE_TEMPLATE', visible: true })
    } else {
      showUpgradePlanModal(availableFrom)
    }
  }

  return (
    <>
      <ToolGeneratorLayoutPrimary
        topContent={
          <WriterHeader
            historyIsVisible={isHistoryVisible}
            setHistoryIsVisible={setIsHistoryVisible}
            headerTitle='modify text'
            toolName='writer-modifyText'
          />
        }
        options={
          <ModifyTextOptions
            visible={!isHistoryVisible}
            dispatch={dispatch}
            actionTypes={actionTypes}
            setWordLength={setWordLength}
            setMyText={setMyText}
            wordLength={wordLength}
            setWhatToDo={setWhatToDo}
            setKeyWords={setKeyWords}
            setWriterLengthOption={setWriterLengthOption}
            writerLengthOption={writerLengthOption}
            setCreativity={setCreativity}
            creativity={creativity}
            optionsData={optionsData}
            templateOptions={templateOptions}
            setTemplateId={setTemplateId}
            allowStandard={allowStandard}
            showUpgradePlanModal={showSaveModal}
            templateId={templateId}
            handleDeleteTemplate={handleDeleteTemplate}
            isShowAdvanced={isShowAdvanced}
            setIsShowAdvanced={setIsShowAdvanced}
            isOptimizedForSeoEnabled={isOptimizedForSeoEnabled}
            setIsOptimizedForSeoEnabled={setIsOptimizedForSeoEnabled}
            isGuruModeEnabled={isGuruModeEnabled}
            setIsGuruModeEnabled={setIsGuruModeEnabled}
            documentContext={documentContext}
            model={model}
            setModel={setModel}
          />
        }
        actions={
          <ModifyTextActions
            clearInputs={clearInputs}
            handleSubmitWriterOptions={handleSubmitWriterOptions}
            loading={loading}
            showSaveModal={showSaveModal}
            allowStandard={allowStandard}
          />
        }
      />
    </>
  )
}

export default ModifyTextGenerator
